/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pen': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.577 5.613l-8.909 8.945-3.243-3.243 8.945-8.909 3.207 3.207zm2.102-3.599c.214.214.315.475.303.784a1.195 1.195 0 0 1-.374.82L14.004 5.22 10.762 1.98 12.365.375c.238-.237.511-.362.82-.374.309-.012.57.089.784.303l1.71 1.71zm-14.539 9.8l3.03 3.029L0 15.983l1.14-4.17z" _fill="#90A4AE" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/pen.js